import { faqData } from '@/mocks/homeData';

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100/80 text-secondary-700 text-xs font-medium mb-4">
            <i className="ri-question-answer-line"></i>
            <span>帮助中心</span>
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500 max-w-md mx-auto">
            关于女神漫画的使用与功能，你想知道的都在这里
          </p>
        </div>

        <div className="space-y-3">
          {faqData.map((item, idx) => (
            <details key={idx} className="group bg-background-100 rounded-lg overflow-hidden cursor-pointer">
              <summary className="flex items-center justify-between px-5 py-4 list-none">
                <h3 className="text-sm md:text-base font-medium text-foreground-800 pr-4">{item.q}</h3>
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 text-foreground-400 group-open:rotate-45 transition-transform duration-200">
                  <i className="ri-add-line"></i>
                </div>
              </summary>
              <div className="px-5 pb-4">
                <p className="text-sm text-foreground-500 leading-relaxed">{item.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}